import { type RouteRecordRaw } from 'vue-router'

import { useSplashScreenStore } from './splashScreen.store'

export const splashScreenRouter: RouteRecordRaw[] = [
  {
    path: '/splashScreen',
    component: async () => import('./splashScreen.vue'),
    async beforeEnter() {
      await useSplashScreenStore.getState().init()
    },
  },
]
